import { PermissionType } from '@apply/constants';
import { hasPermission } from '@apply/ui';
import { AdminActionType } from '../Constants';

export const getAdminActions = (
    profile: { id: number; isLocked: boolean; isDeleted: boolean },
    userState // eslint-disable-line
) => {
    const actions: any[] = []; // eslint-disable-line
    actions.push({
        actionId: AdminActionType.ViewAdminDetails,
        text: hasPermission(PermissionType.AdminUserEdit) ? 'Edit' : 'View',
        id: profile.id,
        stylingMode: 'contained',
        disabled: !(hasPermission(PermissionType.AdminUserView) || hasPermission(PermissionType.AdminUserEdit)),
    });

    if (!profile.isDeleted) {
        actions.push({
            actionId: AdminActionType.ViewAdminRoles,
            text: 'Permissions',
            id: profile.id,
            stylingMode: 'contained',
            disabled: !(hasPermission(PermissionType.PermissionsView) || hasPermission(PermissionType.PermissionsEdit)),
        });

        actions.push({
            actionId: AdminActionType.ResetPassword,
            text: 'Reset Password',
            id: profile.id,
            stylingMode: 'contained',
            disabled: !hasPermission(PermissionType.AdminUserPasswordReset),
        });

        actions.push({
            actionId: AdminActionType.Lockout,
            text: profile.isLocked ? 'Unlock Account' : 'Lock Account',
            id: profile.id,
            isLocked: profile.isLocked,
            stylingMode: 'contained',
            disabled: !hasPermission(PermissionType.AdminUserLockUnlock),
        });
    }

    actions.push({
        actionId: AdminActionType.Delete,
        text: profile.isDeleted ? 'Undelete Account' : 'Delete Account',
        id: profile.id,
        isDeleted: profile.isDeleted,
        stylingMode: 'contained',
        disabled: !profile.isLocked || !hasPermission(PermissionType.AdminUserDelete),
    });

    return actions;
};
